import BaseService from "./BaseService";

export default class NotificationService extends BaseService {

    public getMessages() {
        return this.client.get('/notification/messages');
    }
}